import { Component, Input, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { constants } from '../../utitlity/constant';
import { QuestionBase } from '../question-base';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'ntb-type-ahead-field',
    template: require('./type-ahead-field.component.html'),
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class TypeAheadFieldComponent implements OnInit {
    @Input() question: QuestionBase<any>;
    @Input() questions: any = [];
    @Input() form: NgForm;
    @Input() aelList: any;
    @Output() onNumberChange: EventEmitter<any> = new EventEmitter<any>();
    filteredAelSingle: any[];
    isLeadFormApplication: boolean;

    @ViewChild('fieldValue') fieldValue;

    constructor() { }
    ngOnInit() {
      this.isLeadFormApplication = constants.IS_LEAD_FORM_APPLICATION;
    }
    ngAfterContentInit() {
      if(this.isLeadFormApplication) {
        this.question.value = "";
      }
    }

      //-----------------------------------------------//

  filterAelSingle(event, question) {
    let query = event.query;
    //let invalidChars = /(^\s+|\s+$)/g;
    let invalidChars = /(^\s+)/g;
    query = query.replace(invalidChars, '');
    event.query = event.query.replace(invalidChars, '');

    if(this.isLeadFormApplication) {
      if (query.length >= 3) {
        this.filteredAelSingle = this.filterAel(query, this.aelList);
      } else {
        this.filteredAelSingle = [];
      }
    } else {
      if (query === question.value) {
        if (query.length >= 3) {
          this.filteredAelSingle = this.filterAel(query, this.aelList);
        }else {
          this.filteredAelSingle = [];
        }
      }else {
        question.value = '';
        this.filteredAelSingle = [];
      }
      if(question.value) {
        let name=question.value;
        question.value= {name};
      }
    }
  }

  filterAel(query, Aels: any[]): any[] {
    let filtered: any[] = [];
    for (let i = 0; i < Aels.length; i++) {
      let ael = Aels[i];
      if (ael.name.toLowerCase().indexOf(query.toLowerCase()) === 0 || ael.name.toLowerCase().indexOf(query.toLowerCase()) === 1) {
        filtered.push(ael);
      }
    }
    return filtered;
  }
  //-----------------------------------------------//
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/type-ahead/type-ahead-field.component.ts